import Alpine from 'alpinejs'
import { dispatch } from '../../node_modules/alpinejs/src/utils/dispatch'

Alpine.store('wishlist', {

    numberOfItems: null,
    productIds: [],

    setNumberOfItems(numberOfItems) {
        this.numberOfItems = numberOfItems
    },
    
    setProductIdsOnWishlist(productIds) {
        this.productIds = productIds
    },
    
    isOnWishlist(productId) {
        return this.productIds.indexOf(productId) > -1
    },
    
    setIsOnWishlist(productId, isOn) {
        if(isOn && !this.isOnWishlist(productId)) {
            this.productIds.push(productId)
        }
        if(!isOn && this.isOnWishlist(productId)) {
            this.productIds.splice(this.productIds.indexOf(productId), 1)
        }
    },
    
    async toggle(productId) {
        if(this.isOnWishlist(productId)) {
            await this.removeProduct(productId)
        } else {
            await this.addProduct(productId)
        }
    },

    async addProduct(productId) {
        await Alpine.store('session').updateState('wishlist-add-product')
        if(!Alpine.store('session').authenticated) {
            return
        }
        
        const url = '/ws/wishlist/add'
            +'/sku/'+productId
            +'/form_key/'+Alpine.store('session').token

        return fetch(url, {
            
            credentials: 'include'
            
        }).then(response => {
            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()
            
        }).then(data => {
            
            if(data.status === 'ok') {
                this.setIsOnWishlist(productId, true)
                this.setNumberOfItems(data.numberOfItems)
                
                const eventParams = {
                    productId: productId,
                }
                if(data.uniqueEventId) {
                    eventParams.metaEventId = data.uniqueEventId
                }
                
                dispatch(window, 'wishlist-item-added', eventParams)
            }
            
        }).catch(error => {
            console.log(error)
        })
    },

    async removeProduct(productId) {
        await Alpine.store('session').updateState('wishlist-remove-product')
        if(!Alpine.store('session').authenticated) {
            return
        }

        const url = '/ws/wishlist/remove'
            +'/sku/'+productId
            +'/form_key/'+Alpine.store('session').token

        return fetch(url, {
            
            credentials: 'include'
            
        }).then(response => {
            
            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()

        }).then(data => {

            if(data.status === 'ok') {
                this.setIsOnWishlist(productId, false)
                this.setNumberOfItems(data.numberOfItems)

                dispatch(window, 'wishlist-item-removed', { productId: productId })
            }

        }).catch(error => {
            console.log(error)
        })
    }
})